import {Component, Input, OnDestroy} from '@angular/core';
import {map, tap} from 'rxjs/operators';
import {Observable,} from 'rxjs';
import {DcpSupportFormService} from '../support-form/dcp-support-form.service';
import {IDcpGlobalErrorMessage} from '@app/core/models/interfaces/error';
import {GlobalMessageType} from '@spartacus/core';
import {DcpGlobalMessageService} from '@dcp/configurator';

@Component({
  selector: 'dcp-disposable-message',
  templateUrl: './disposable-message.component.html',
})
export class DisposableMessageComponent implements OnDestroy {

  @Input() showActiveTemplate: boolean = true;

  constructor(
    public dcpGlobalMessageService: DcpGlobalMessageService,
    public dcpSupportFormService: DcpSupportFormService,
  ) {
  }

  ngOnDestroy() {
    this.dcpGlobalMessageService.resetMessages();
    this.dcpGlobalMessageService.setActiveTemplate(null);
  }

  convertMessagesToStrings(disposableMessages: IDcpGlobalErrorMessage[]): string[] {
    return disposableMessages.map((disposableMessage) => disposableMessage.message);
  }

  getMessageType(disposableMessages: IDcpGlobalErrorMessage[]): 'warning' | 'error' {
    return disposableMessages.find((msg) => msg.type === GlobalMessageType.MSG_TYPE_ERROR) ? 'error' : 'warning';
  }

  filteredDisposableMessages(type: GlobalMessageType): Observable<IDcpGlobalErrorMessage[]> {
    return this.dcpGlobalMessageService.getActiveMessages().pipe(
      map(messages => messages.filter(message => message.type === type)),
      map(messages => this.filterDuplicateMessages(messages)),
    );
  }

  filterDuplicateMessages(messages: IDcpGlobalErrorMessage[]): IDcpGlobalErrorMessage[] {
    return messages.filter((value, index, self) =>
      index === self.findIndex((target) => target.message === value.message)
    );
  }

  filteredErrorMessages(): Observable<IDcpGlobalErrorMessage[]> {
    return this.filteredDisposableMessages(GlobalMessageType.MSG_TYPE_ERROR);
  }

  filteredWarningMessages(): Observable<IDcpGlobalErrorMessage[]> {
    return this.filteredDisposableMessages(GlobalMessageType.MSG_TYPE_WARNING);
  }

  filteredInfoMessages(): Observable<IDcpGlobalErrorMessage[]> {
    return this.filteredDisposableMessages(GlobalMessageType.MSG_TYPE_INFO);
  }

  filteredConfirmationMessages(): Observable<IDcpGlobalErrorMessage[]> {
    const messages = this.filteredDisposableMessages(GlobalMessageType.MSG_TYPE_CONFIRMATION);
    //filter messages by group: if potentialPromotions msgs are present => reorder the array to put them last
    return messages.pipe(
      tap(msgs => msgs
        .sort((a, b) => a.group.localeCompare(b.group))
      )
    );
  }

  contactSupport(message: string, code: string): void {
    this.dcpSupportFormService.open(message, code);
  }

  removeMessages(messagesToRemove: IDcpGlobalErrorMessage[]) {
    messagesToRemove.forEach(msg => this.dcpGlobalMessageService.removeMessage(msg.id));
  }
}
